import { render, staticRenderFns } from "./InvalidMailModal.vue?vue&type=template&id=52dc2905&scoped=true&lang=pug&"
import script from "./InvalidMailModal.vue?vue&type=script&lang=js&"
export * from "./InvalidMailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc2905",
  null
  
)

export default component.exports